// Custom Turbo Stream action to close a modal and reset its form
import { StreamActions } from "@hotwired/turbo"

StreamActions.modal_close = function() {
  // Find the modal element
  const modalId = this.getAttribute("target")
  const modalElement = document.getElementById(modalId)

  if (modalElement) {
    // Dispatch a custom event to close the modal
    modalElement.dispatchEvent(new CustomEvent("modal:close"))

    // Reset any forms inside the modal after a short delay to allow the modal to close
    setTimeout(() => {
      const forms = modalElement.querySelectorAll("form")
      forms.forEach(form => {
        form.reset()
        // Clear any validation errors or messages
        const errorMessages = form.querySelectorAll(".error-message, .field_with_errors")
        errorMessages.forEach(error => error.remove())
      })
    }, 100)
  }
}